import * as React from "react"

function Autorizzate(props) {
    return (
        <svg
            id="Autorizzate"
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 50 50"
            xmlSpace="preserve"
            {...props}
        >
            <path
                className="prefix__st0"
                d="M36.5 21.6C36.5 15.2 31.4 10 25 10s-11.5 5.2-11.5 11.5C13.5 27.9 18.7 33 25 33c6.4.1 11.5-5.1 11.5-11.4z"
            />
            <path
                className="prefix__st0"
                d="M40.8 21.6c0-8.7-7.1-15.8-15.8-15.8s-15.8 7-15.8 15.8c0 8.7 7.1 15.8 15.8 15.8s15.8-7.1 15.8-15.8z"
            />
            <path
                className="prefix__st0"
                d="M31.4 36.1l8.1 8.1v-8.1h8.1L39.5 28M18.6 36.1l-8.1 8.1v-8.1H2.4l8.1-8.1M23.1 15.9h4.1v3.3h3.3v4.5h-3.3V27h-4.5v-3.3h-3.3v-4.5h3.7z"
            />
        </svg>
    )
}

export default Autorizzate
